<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-4">
          Employee
        </div>
        <div class="col-md-8 padding-right-0px">
          <div class="row">
            <div class="offset-md-6 col-md-2 padding-right-0px text-align-right">
              <a (click)="AddNewEmployee()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Employee"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
            </div>
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <form novalidate="" #f="ngForm" class="display-inherit">
                <div class="clear-form">
                  <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">
                </div>
                <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>

                    <th class="">
                      Name
                    </th>

                    <th class="">
                      Gender
                    </th>

                    <th class="">
                      Designation
                    </th>

                    <th class="">
                      Employee ID
                    </th>
                    <th class="">
                      Base Location
                    </th>

                    <th class="">
                      Contact No
                    </th>

                    <th class="">
                      Email
                    </th>
                    <th class="">

                    </th>

                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr>

                    <td class=" td-padding-tb">Sudheer</td>
                    <td class=" td-padding-tb">Male</td>
                    <td class="td-padding-tb">Admin</td>
                    <td class=" td-padding-tb">001</td>
                    <td class="td-padding-tb">Kalyan Nagar</td>
                    <td class="td-padding-tb ">8801667136</td>
                    <td class="td-padding-tb ">kallanaveen211&#64;gmail.com</td>
                    <td class=" td-padding-tb ">
                      <button (click)="EditEmpl()" type="submit" class="button-service-save padding-right-15px font-size-16px color-secondary nav-link-hand margin-left-3px"><i class="fas fa-pencil-alt"></i></button>
                      <a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                    </td>

                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="AddEmployee">
    <div class="columnbr1">
      <div class="col-md-12 wh-header">
        <div class="row padding-bottom-6px">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To Employee"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Add New Employee
        </div>

        <div id="profile">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          Profile
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Name Prefix</label>
                          </div>


                          <div class="col-md-1">

                            <CodeTypeValue CodeType="NPRE"></CodeTypeValue>

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Name</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Name"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Prime Relation</label>
                          </div>

                          <div class="col-md-1">

                            <CodeTypeValue CodeType="NPRE"></CodeTypeValue>

                          </div>
                          <div class="col-md-3">

                            <input type="text" class="form-control" placeholder="Prime Relation"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="demographics">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample2">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne2">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne2" aria-expanded="true" aria-controls="collapseOne2">
                          Demographics
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne2" class="collapse show" aria-labelledby="headingOne2" data-parent="#accordionExample2">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Date of Birth</label>
                          </div>


                          <div class="col-md-4">

                            <div class="date-form">
                              <input class="form-control" placeholder="DOB" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" ngbDatepicker #d1="ngbDatepicker">
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Gender</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="Sex"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Marital Status</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Blood Group</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="BGRP"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Nationality</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="NATN"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Base Location</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="NATN"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Department</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="NATN"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Designation</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Designation"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Provider</label>
                          </div>


                          <div class="col-md-1">

                            <input type="checkbox" class="width-15px margin-top-10">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Employment Type</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Joining Date</label>
                          </div>


                          <div class="col-md-4">

                            <div class="date-form">
                              <input class="form-control" placeholder="DOJ" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp2" ngbDatepicker #d2="ngbDatepicker">
                              <a (click)="d2.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Employee Old ID</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Employee Old ID"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="education">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample3">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                          Education Details
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Education Level</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="EDU"></CodeTypeValue>

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Education in Detail</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Education in Detail"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="user">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample4">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                          User Account Details
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Select User Name</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="User Name"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="branch">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample5">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne5">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">
                          Branch Mapping
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne5" class="collapse show" aria-labelledby="headingOne5" data-parent="#accordionExample5">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <!--<div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Locations</label>
                          </div>

                        </div>


                      </div>
                    </div>-->

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">

                          </div>
                          <div class="col-md-5">

                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-zero width-100pe bk-color-lightgray"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>

                                      <th class="">

                                      </th>

                                      <th class="">
                                        Code
                                      </th>

                                      <th class="">
                                        Name
                                      </th>

                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr>

                                      <td class=" td-padding-tb">
                                        <input type="checkbox" class="width-15px">
                                      </td>
                                      <td class=" td-padding-tb">GG2</td>
                                      <td class="td-padding-tb">Garbhagudi-Kalyan Nagar</td>

                                    </tr>
                                    <tr>

                                      <td class=" td-padding-tb">
                                        <input type="checkbox" class="width-15px">
                                      </td>
                                      <td class=" td-padding-tb">GGHO</td>
                                      <td class="td-padding-tb">Garbhagudi-SouthEnd</td>

                                    </tr>

                                  </tbody>

                                </table>
                              </div>
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="contact">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample6">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                          Contact Address
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Line 1</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Line 1"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Line 2</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Line 2"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Country</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="CNTR"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">State</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="State"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">City</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="City"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Zip Code</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Zip Code"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="contactdetails">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample7">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne7">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne7" aria-expanded="true" aria-controls="collapseOne7">
                          Contact Details
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7" data-parent="#accordionExample7">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Mobile Phone</label>
                          </div>


                          <div class="col-md-4">

                            <input type="tel" class="form-control" placeholder="Mobile Phone"
                                   mask="(000) 000-0000" pattern="[0-9]{10}">

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Email Address</label>
                          </div>


                          <div class="col-md-4">

                            <input type="email" class="form-control" placeholder="Email Address"
                                   pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="image">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample8">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne8">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne8" aria-expanded="true" aria-controls="collapseOne8">
                          Image
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne8" class="collapse show" aria-labelledby="headingOne8" data-parent="#accordionExample8">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="text-align-center">
                            <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
                            <div><img [src]="url" class="img-100px" *ngIf="url"></div>
                            <div class="font-size-14px padding-left-25px padding-top-5px">
                              <input type="file" class="text-align-center" (change)="selectFile($event)">
                            </div>
                            </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="signature">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample9">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne9">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne9" aria-expanded="true" aria-controls="collapseOne9">
                          Signature
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne9" class="collapse show" aria-labelledby="headingOne9" data-parent="#accordionExample9">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="text-align-center">
                            <div [innerHtml]='msg2' *ngIf="msg2" style="color: red;"></div>
                            <div><img [src]="url2" class="img-30px" *ngIf="url2"></div>
                            <div class="font-size-14px padding-left-25px padding-top-5px">
                              <input type="file" class="text-align-center" (change)="selectFile2($event)">
                            </div>
                            </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
    <div class="columnbr2">
      <div class="accordion" id="accordionExample6">
        <div class="card margin-bottom-5px">
          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
            <div class="row">
              <div class="col-md-5">
                <h5 class="mb-0 height-24px">
                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                    Sections
                  </button>
                </h5>


              </div>

            </div>


          </div>

          <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="profile()">Profile</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="demographics()">Demographics</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="education()">Education Details</a>

              </div>


              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="user()">User Account Details</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="branch()">Branch Mapping</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="contact()">Contact Address</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="contactdetails()">Contact Details</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="image()">Image</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="signature()">Signature</a>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="EditEmployee">
    <div class="columnbr1">
      <div class="col-md-12 wh-header">
        <div class="row padding-bottom-6px">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To Employee"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Edit Employee
        </div>

        <div id="profile">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          Profile
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Name Prefix</label>
                          </div>


                          <div class="col-md-1">

                            <CodeTypeValue CodeType="NPRE"></CodeTypeValue>

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Name</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Name"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Prime Relation</label>
                          </div>

                          <div class="col-md-1">

                            <CodeTypeValue CodeType="NPRE"></CodeTypeValue>

                          </div>
                          <div class="col-md-3">

                            <input type="text" class="form-control" placeholder="Prime Relation"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="demographics">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample2">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne2">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne2" aria-expanded="true" aria-controls="collapseOne2">
                          Demographics
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne2" class="collapse show" aria-labelledby="headingOne2" data-parent="#accordionExample2">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Date of Birth</label>
                          </div>


                          <div class="col-md-4">

                            <div class="date-form">
                              <input class="form-control" placeholder="DOB" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" ngbDatepicker #d1="ngbDatepicker">
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Gender</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="Sex"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Marital Status</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Blood Group</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="BGRP"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Nationality</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="NATN"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Base Location</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="NATN"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Department</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="NATN"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Designation</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Designation"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Provider</label>
                          </div>


                          <div class="col-md-1">

                            <input type="checkbox" class="width-15px margin-top-10">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Employment Type</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Joining Date</label>
                          </div>


                          <div class="col-md-4">

                            <div class="date-form">
                              <input class="form-control" placeholder="DOJ" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp2" ngbDatepicker #d2="ngbDatepicker">
                              <a (click)="d2.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Employee Old ID</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Employee Old ID"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="education">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample3">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                          Education Details
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Education Level</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="EDU"></CodeTypeValue>

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Education in Detail</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Education in Detail"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="user">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample4">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                          User Account Details
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Select User Name</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="User Name"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="branch">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample5">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne5">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">
                          Branch Mapping
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne5" class="collapse show" aria-labelledby="headingOne5" data-parent="#accordionExample5">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <!--<div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Locations</label>
                          </div>

                        </div>


                      </div>
                    </div>-->

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">

                          </div>
                          <div class="col-md-5">

                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-zero width-100pe bk-color-lightgray"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>

                                      <th class="">

                                      </th>

                                      <th class="">
                                        Code
                                      </th>

                                      <th class="">
                                        Name
                                      </th>

                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr>

                                      <td class=" td-padding-tb">
                                        <input type="checkbox" class="width-15px">
                                      </td>
                                      <td class=" td-padding-tb">GG2</td>
                                      <td class="td-padding-tb">Garbhagudi-Kalyan Nagar</td>

                                    </tr>
                                    <tr>

                                      <td class=" td-padding-tb">
                                        <input type="checkbox" class="width-15px">
                                      </td>
                                      <td class=" td-padding-tb">GGHO</td>
                                      <td class="td-padding-tb">Garbhagudi-SouthEnd</td>

                                    </tr>

                                  </tbody>

                                </table>
                              </div>
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="contact">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample6">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                          Contact Address
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Line 1</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Line 1"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Line 2</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Line 2"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Country</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="CNTR"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">State</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="State"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">City</label>
                          </div>


                          <div class="col-md-4">

                            <CodeTypeValue CodeType="City"></CodeTypeValue>

                          </div>

                        </div>


                      </div>
                    </div>

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Zip Code</label>
                          </div>


                          <div class="col-md-4">

                            <input type="text" class="form-control" placeholder="Zip Code"
                                   pattern="^[\0-9,._\-?]*$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="contactdetails">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample7">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne7">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne7" aria-expanded="true" aria-controls="collapseOne7">
                          Contact Details
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7" data-parent="#accordionExample7">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Mobile Phone</label>
                          </div>


                          <div class="col-md-4">

                            <input type="tel" class="form-control" placeholder="Mobile Phone"
                                   mask="(000) 000-0000" pattern="[0-9]{10}">

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row my-profile-form">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-4 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                            <label for="diaplayName" class="font-size-12px font-weight-normal margin-bottom-0px">Email Address</label>
                          </div>


                          <div class="col-md-4">

                            <input type="email" class="form-control" placeholder="Email Address"
                                   pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$">

                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="image">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample8">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne8">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne8" aria-expanded="true" aria-controls="collapseOne8">
                          Image
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne8" class="collapse show" aria-labelledby="headingOne8" data-parent="#accordionExample8">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">


                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div id="signature">
          <form class="form " novalidate="" #f="ngForm">
            <div class="accordion" id="accordionExample9">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne9">
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne9" aria-expanded="true" aria-controls="collapseOne9">
                          Signature
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-2">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                    </div>
                  </div>


                </div>

                <div id="collapseOne9" class="collapse show" aria-labelledby="headingOne9" data-parent="#accordionExample9">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">


                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
    <div class="columnbr2">
      <div class="accordion" id="accordionExample6">
        <div class="card margin-bottom-5px">
          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
            <div class="row">
              <div class="col-md-5">
                <h5 class="mb-0 height-24px">
                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                    Sections
                  </button>
                </h5>


              </div>

            </div>


          </div>

          <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="profile()">Profile</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="demographics()">Demographics</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="education()">Education Details</a>

              </div>


              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="user()">User Account Details</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="branch()">Branch Mapping</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="contact()">Contact Address</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="contactdetails()">Contact Details</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="image()">Image</a>

              </div>
              <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="signature()">Signature</a>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  

</div>

<!--<div class="col-md-12" *ngIf="!ShowList">

  <profileview (GoBack)="OnGoBack()"
               [FormattedCode]="SelectedPatient.FormattedCode" [DisplayName]="SelectedPatient.DisplayName" *ngIf="ShowPatientDetails"></profileview>
</div>-->

